import api, { ResponsePayloadWithData } from '.';
import { ModulePublishingState } from '../@types/module-publishing-state';

export const MEDIALINK_SORTING_OPTION = {
  CATEGORY: 'category',
  LESSON: 'lesson_order',
} as const;

export type MedialinkSorting = typeof MEDIALINK_SORTING_OPTION[keyof typeof MEDIALINK_SORTING_OPTION];

export type Module = {
  id: string;
  name: string;
  niceName: string;
  catalogName: string;
  slug: string;
  methodSlug: string;
  subjectName: string;
  subjectSlug: string;
  years: string[];
  weight: number;
  incomplete: boolean;
  hasExercises: boolean;
  hasExerciseEntrance: boolean;
  defaultSorting?: MedialinkSorting;
  disableLessonSorting: boolean;
  hostedExternally: boolean;
  subModules: string[];
  licenses: {
    hasDemoProductLicenseForTeacher: boolean;
    hasDigitalManualLicenseForTeacher: boolean;
    hasDocumentLicenseForTeacher: boolean;
    hasDocumentLicenseForStudent: boolean;
    isActiveBook: boolean;
  };
  bookType?: string;
  releaseDate?: string;
  styling?: {
    logo?: string;
    visual?: string;
    cover?: string;
    primaryColor?: string;
  };
  externalContentUrl?: string;
  enableSlideSetsAccess: boolean;
  isExerciseModule: boolean;
  publishingState: ModulePublishingState;
  counts: {
    slideSets?: number;
    studentExercises: number;
    teacherExercises: number;
    studentOtherMaterials: number;
    teacherOtherMaterials: number;
  };
};

export const getModuleBySlug = async (moduleSlug: string) => {
  return api.get<Module>(`/studio/modules/slug/${moduleSlug}`);
};

export const getSubModulesForModule = async (moduleId: string) => {
  const { data } = await api.get<ResponsePayloadWithData<Module[]>>(`/studio/modules/${moduleId}/sub-modules`);

  return data;
};

export async function getModuleById(moduleId: string) {
  const { data } = await api.get<Module>(`/studio/modules/${moduleId}`);

  return data;
}
